import { useNavigate } from 'react-router-dom';
import AutumnalDecorations from './AutumnalDecorations';

const HOTELS = [
  { name: 'The Samuel Palmer', note: 'walking distance', phone: '01959 525442', website: 'https://thesamuelpalmer.com/' },
  { name: 'White Hill Woods', note: 'walking distance', phone: '07889 998988', website: 'https://whitehillwoods.co.uk/' },
  { name: 'Darent Hulme', phone: '01959 525656', website: 'https://www.darenthulme.co.uk/' },
  { name: 'The Castle', phone: '01322 633917', website: 'https://www.castlehotelkent.com/' },
  { name: 'Premier Inn Sevenoaks', phone: '01732 496392', website: 'https://www.premierinn.com/gb/en/hotels/england/kent/sevenoaks/sevenoaks.html' },
  { name: 'Mercure Brands Hatch', phone: '01474 854900', website: 'https://all.accor.com/hotel/A0I7/index.en.shtml' },
];

const TAXIS = [
  { name: 'Bee Line Taxis', phone: '01732 456214' },
  { name: 'TN14 Cars', phone: '07938 971002' },
];

export default function GuestInfoView() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-autumn-cream relative">
      <AutumnalDecorations intensity="light" />

      {/* Header */}
      <header className="sticky top-0 z-30 bg-autumn-cream/95 backdrop-blur-sm border-b border-autumn-gold/10">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="text-autumn-light-brown hover:text-autumn-brown transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>
          <h1 className="text-xl md:text-2xl font-display font-semibold text-autumn-brown">
            Guest Information
          </h1>
        </div>
      </header>

      {/* Content */}
      <main className="relative z-10 max-w-2xl mx-auto px-4 py-10">

        {/* Hotels */}
        <section className="mb-10">
          <h2 className="text-2xl font-display font-semibold text-autumn-brown mb-4">Hotels</h2>
          <div className="space-y-3">
            {HOTELS.map((hotel) => (
              <div key={hotel.name} className="bg-white rounded-lg p-4 shadow-sm flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4">
                <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
                  <span className="font-display text-autumn-brown">{hotel.name}</span>
                  {hotel.note && (
                    <span className="text-autumn-light-brown italic text-sm">({hotel.note})</span>
                  )}
                  {hotel.website && (
                    <a
                      href={hotel.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-autumn-orange hover:text-autumn-red font-body text-sm underline transition-colors"
                    >
                      Visit website
                    </a>
                  )}
                </div>
                <a
                  href={`tel:${hotel.phone.replace(/\s/g, '')}`}
                  className="text-autumn-orange hover:text-autumn-red font-body whitespace-nowrap transition-colors"
                >
                  {hotel.phone}
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* Gifts */}
        <section className="mb-10">
          <h2 className="text-2xl font-display font-semibold text-autumn-brown mb-4">Gifts</h2>
          <p className="font-body text-autumn-light-brown italic leading-relaxed">
            We don't need presents, just your presence. But if you'd like to, we would love TUI vouchers or money to put towards a honeymoon in the future. Thank you.
          </p>
        </section>

        {/* Parking */}
        <section className="mb-10">
          <h2 className="text-2xl font-display font-semibold text-autumn-brown mb-4">Parking</h2>
          <p className="font-body text-autumn-light-brown">
            There is plenty of parking on site.
          </p>
        </section>

        {/* Carriages */}
        <section className="mb-10">
          <h2 className="text-2xl font-display font-semibold text-autumn-brown mb-4">Carriages</h2>
          <p className="font-body text-autumn-light-brown">
            Carriages at midnight.
          </p>
        </section>

        {/* Taxis */}
        <section className="mb-10">
          <h2 className="text-2xl font-display font-semibold text-autumn-brown mb-4">Taxis</h2>
          <div className="space-y-3">
            {TAXIS.map((taxi) => (
              <div key={taxi.name} className="bg-white rounded-lg p-4 shadow-sm flex items-center justify-between gap-4">
                <span className="font-display text-autumn-brown">{taxi.name}</span>
                <a
                  href={`tel:${taxi.phone.replace(/\s/g, '')}`}
                  className="text-autumn-orange hover:text-autumn-red font-body whitespace-nowrap transition-colors"
                >
                  {taxi.phone}
                </a>
              </div>
            ))}
          </div>
        </section>

      </main>
    </div>
  );
}
